import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from "axios";

const PrivateRouteWithPlan = ({ children }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [hasPlan, setHasPlan] = useState(false);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }

    axios
      .get(`${process.env.REACT_APP_MAIN_SITE_URL}/user/has-plan`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setHasPlan(res.data.has_plan);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setHasPlan(false);
      });
  }, [token]);

  if (!token) return <Navigate to="/signin" replace />;
  if (loading) return <div>Loading...</div>;

  return hasPlan ? (
    children
  ) : (
    <Navigate
      to="/pricing"
      replace
      state={{
        from: location.pathname,
        groupId: location.state?.groupId || null,
      }}
    />
  );
};

export default PrivateRouteWithPlan;
